// Shared framer-motion variants for consistent, purposeful motion.
export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1, ease: EASE } },
};

export const stagger = (staggerChildren = 0.12, delayChildren = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren, delayChildren } },
});

// Masked line reveal — inner element animates from y:100% inside an
// overflow-hidden wrapper.
export const maskLine = {
  hidden: { y: "110%" },
  visible: (i = 0) => ({
    y: "0%",
    transition: { duration: 1, ease: EASE, delay: 0.15 * i },
  }),
};

export const viewport = { once: true, margin: "-12%" };

// Editorial text reveal: the copy sweeps in from the right while resolving
// from soft blur to crisp type.
export const sweepFromRight = {
  hidden: {
    opacity: 0,
    x: 52,
    filter: "blur(12px)",
    clipPath: "inset(0 0 0 100%)",
  },
  visible: (delay = 0) => ({
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    clipPath: "inset(0 0 0 0%)",
    transition: { duration: 0.95, ease: EASE, delay },
  }),
};
